module.exports = __webpack_public_path__ + "static/forecast/weather/daymodsnow-a3cacb974b227d56738790c112b63f90.svg";